import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ProofAfterEndPage } from './proof-after-end';

@NgModule({
  declarations: [
    ProofAfterEndPage,
  ],
  imports: [
    IonicPageModule.forChild(ProofAfterEndPage),
  ],
  exports: [
    ProofAfterEndPage
  ]
})
export class ProofAfterEndPageModule { }



// WEBPACK FOOTER //
// ./src/pages/proof-after-end/proof-after-end.module.ts